import React from 'react';
import loadable from '@loadable/component';
import connectRoute from 'app/routes/connectRoute';
import EventsActions from 'app/actions/EventsActions';

const MyEventsPageContainer = loadable(() => import('app/components/events/MyEventsPage/MyEventsPageContainer'));

export function MyEventsPageRoute(props) {
  return <MyEventsPageContainer {...props} />;
}

function getRouteData({ dispatch, query }) {
  return [dispatch(EventsActions.getMyEvents(query))];
}

export default connectRoute(MyEventsPageRoute, {
  getRouteData,
  debounceOptions: {
    wait: 100 // milliseconds
  }
});
